import { defineComponent } from 'vue';
import { IOverlappingEntity } from '@/models/overlapping-campaigns.interface';
import OverlappingCampaignsListCode
	from '@/presentation/components/shared/overlapping-campaigns-modal/overlapping-campaign-list/overlapping-campaigns-list.code';

export default defineComponent({
	props: {
		entityName: {
			type: String,
			required: true
		},
		entities: {
			type: Array,
			required: true
		}
	},
	setup: (props) => {
		const code = new OverlappingCampaignsListCode();

		return {
			entityName: props.entityName,
			entities: props.entities as IOverlappingEntity[],
			constructCampaignEditorLink: code.constructCampaignEditorLink.bind(code)
		};
	}
});
